import { memo } from 'react';

import { convertStatus, convertStatusUrl } from '../../../../api/enumerations';
import { WorkOrderData } from '../../../../api/workOrders/types';
import { IconWarningMS } from '../../../../constants/icons';
import { CHART_TITLES } from '../../constants';
import { criticalOrders } from '../../utils/aggregations';
import { ChartCard } from '../ChartCard';
import { Empty, Item, List, TitleWithIcon } from './styles';

interface CriticalListProps {
  data: WorkOrderData[];
}

function CriticalListImpl({ data }: CriticalListProps): JSX.Element {
  const top = criticalOrders(data, 5);

  return (
    <ChartCard
      title={CHART_TITLES.criticalList}
      ariaLabel={`Top ${top.length} OS atrasadas: ${top
        .map(
          (it) =>
            `OS ${it.reference_number}, ${Math.abs(
              it.sla_days_remaining ?? 0
            )} dias atrasada`
        )
        .join('; ')}.`}
    >
      <TitleWithIcon aria-hidden="true">{IconWarningMS}</TitleWithIcon>
      {top.length === 0 ? (
        <Empty>nenhuma OS atrasada no período</Empty>
      ) : (
        <List>
          {top.map((it) => {
            const days = Math.abs(it.sla_days_remaining ?? 0);
            return (
              <Item
                key={it.id}
                to={`/home/property/${it.id}/${convertStatusUrl(it.status)}`}
              >
                <strong>
                  OS {it.reference_number} •{' '}
                  <span className="late">{days}d atrasada</span>
                </strong>
                <span>{it.client_name || '—'}</span>
                <span className="meta">
                  {it.worker_company?.name || 'sem empresa'} •{' '}
                  {convertStatus(it.status)}
                </span>
              </Item>
            );
          })}
        </List>
      )}
    </ChartCard>
  );
}

export const CriticalList = memo(CriticalListImpl);
